import { Component, OnInit } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LimitPopupService } from '../../services/limit-popup.service';
import {environment} from "../../../environments/environment";
import {UTMService} from "../../services/utm.service";
import {TrackerService} from "../../services/tracker.service";
import {TrackingService} from "../../services/tracking.service";

@Component({
    selector: 'app-limit-popup',
    imports: [CommonModule, NgOptimizedImage],
    template: `
    @if (limitPopupService.limitReached$ | async) {
      <div class="limit-popup-overlay">
        <div class="limit-popup-content">
          <div class="limit-popup-message">
            <h2 i18n="Component 'limit-popup', popup, title@@limit-popup_component.popup.title">Oh ! Le voile de la gratuité s'est refermé...</h2>
            <div>
              <img ngSrc="assets/img/isabella_limit.png" alt="" width="100" height="93" />
              <div>
                <p i18n="Component 'limit-popup', popup, content@@limit-popup_component.popup.content">C'est le moment de nous retrouver sur ma page Wengo pour poursuivre notre voyage !</p>
              </div>
            </div>
            <a [href]="isabellaUrl" title="C'est par ici !"
              (click)="goIsabella()"
              i18n-title="Component 'limit-popup', popup, Isabella on Wengo link label@@limit-popup_component.popup.wengo_link.label"
            i18n="Component 'limit-popup', popup, Isabella on Wengo link label@@limit-popup_component.popup.wengo_link.label">C'est par ici !</a>
          </div>
        </div>
      </div>
    }
    `,
    styleUrls: ['./limit-popup.component.scss']
})
export class LimitPopupComponent implements OnInit {

  constructor(public limitPopupService: LimitPopupService,
              private utmService: UTMService,
              private trackerService: TrackerService,
              private trackingService: TrackingService) { }

  get isabellaUrl(): string {
    const url = new URL($localize`:Component 'limit-popup', popup, Isabella on Wengo link href@@limit-popup_component.popup.wengo_link.href:https://www.wengo.fr/voyance-astrologie/4417776-astrologie-tirages-de-cartes-guidance`);
    // les UTM de la campagne qui a amene le visiteur (ou celles de l'app), signees de l'emplacement dans utm_term
    for (const [k, v] of Object.entries(this.utmService.appLinkUtm('limite-popup'))) {
      url.searchParams.set(k, v);
    }
    const trackerData = this.trackerService.getCurrentTrackerData(this.trackerService.getDefaultTrackerData());
    if (trackerData) {
      const trackers = this.trackerService.urlFormat(trackerData);
      for (const [k, v] of Object.entries(trackers)) {
        url.searchParams.set(k, v);
      }
    }
    return url.toString();
  }

  ngOnInit(): void {
  }

  public goIsabella() {
    this.trackingService.gameEvent('ClickCTALimitPopin');
  }
}
